import {
  createAsyncActions,
  runAsyncWorkflow
} from '../lib/reduxHelpers';

import { EceProgram } from '../api';

export const [
    fetchEceStaticContent,
    receiveEceStaticContent,
    eceStaticContentError
  ] = createAsyncActions(
    'ECE_STATIC_HOME_TEXT',
    () => ({  }),
    ({ data }) => ({ data })
  );
  
export const getEceStaticContent = ( locale, page ) => {
  const fetchPromise = EceProgram.getEceStaticContent( locale, page );

  return runAsyncWorkflow({
      fetch: fetchEceStaticContent,
      receive: receiveEceStaticContent,
      error: eceStaticContentError
    },fetchPromise)
};

export const [
  fetchEceThemes,
  receiveEceThemes,
  eceThemesError
] = createAsyncActions(
  'GET_ECE_THEMES',
  () => ({ }),
  ({ data }) => ({ data })
);

export const getEceThemes = ( locale, page ) => {
const fetchPromise = EceProgram.getEceThemes( locale, page );

return runAsyncWorkflow({
    fetch: fetchEceThemes,
    receive: receiveEceThemes,
    error: eceThemesError
  },fetchPromise)
};

export const [
  fetchEcePosters,
  receiveEcePosters,
  ecePostersError
] = createAsyncActions(
  'GET_ECE_POSTERS',
  () => ({ }),
  ({ data }) => ({ data })
);

export const getEcePosters = ( locale, page, posterArray ) => {
const fetchPromise = EceProgram.getEcePosters( locale, page, posterArray );

return runAsyncWorkflow({
    fetch: fetchEcePosters,
    receive: receiveEcePosters,
    error: ecePostersError
  },fetchPromise)
};

export const [
  fetchEceStories,
  receiveEceStories,
  eceStoriesError
] = createAsyncActions(
  'GET_ECE_STORIES',
  () => ({ }),
  ({ data }) => ({ data })
);

export const getEceStories = ( idr, locale, filters ) => {
const fetchPromise = EceProgram.getEceStories( idr, locale, filters );

return runAsyncWorkflow({
    fetch: fetchEceStories,
    receive: receiveEceStories,
    error: eceStoriesError
  },fetchPromise)
};

export const [
  fetchEceVideos,
  receiveEceVideos,
  eceVideosError
] = createAsyncActions(
  'GET_ECE_VIDEOS',
  () => ({ }),
  ({ data }) => ({ data })
);

export const getEceVideos = ( locale, page ) => {
const fetchPromise = EceProgram.getEceVideos( locale, page );

return runAsyncWorkflow({
    fetch: fetchEceVideos,
    receive: receiveEceVideos,
    error: eceVideosError
  },fetchPromise)
};

export const [
  fetchEceResources,
  receiveEceResources,
  eceResourcesError
] = createAsyncActions(
  'GET_ECE_RESOURCES',
  () => ({ }),
  ({ data }) => ({ data })
);

export const getEceResources = ( locale ) => {
const fetchPromise = EceProgram.getEceResources( locale );

return runAsyncWorkflow({
    fetch: fetchEceResources,
    receive: receiveEceResources,
    error: eceResourcesError
  },fetchPromise)
};

export const [
  fetchGetEceLevelsFilters,
  recieveGetEceLevelsFilters,
  getEceLevelsFiltersError
] = createAsyncActions(
  'GET_ECE_LEVEL_FILTERS',
  slug => ({ slug }),
  ({ data }) => ({ levels : data })
);

export const getEceLevelFilters = (locale) => {
  const fetchPromise = EceProgram.getEceLevelFilters(locale);

  return runAsyncWorkflow({
    fetch: fetchGetEceLevelsFilters,
    receive: recieveGetEceLevelsFilters,
    error: getEceLevelsFiltersError
  }, fetchPromise)
}

export const [
  postDownload,
  recievePostDownload,
  postDownloadError
] = createAsyncActions(
  'ECE_POST_DOWNLOAD',
  ({    user_id , locale }) => ({  user_id , locale }),
  ({  ok, url}) => ({  ok, url})
);

export const postDownloadWorkflow =  (  user_id , locale ) => {
  const fetchPromise = EceProgram.postDownload(   user_id , locale );

  return runAsyncWorkflow({
    fetch: postDownload,
    receive: recievePostDownload,
    error:   postDownloadError
  }, fetchPromise)
}



// WEBPACK FOOTER //
// ./src/redux/eceActions.js